exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".paginationControls{text-align:center}.paginationControls .control{margin:0 .4em}.paginationControls .pageLabel{margin:0 2.3em}.paginationControls .perPage{position:relative;top:-1px;color:#999;margin-left:5px}.paginationControls .perPage .buttonDropdown button.btn{padding:0;color:#999}.paginationControls .perPage .buttonDropdown button.btn .caret{margin-left:2px}.paginationControls .perPage .dropdown-menu{font-size:.8em;min-width:75px}.paginationControls .perPage .dropdown-menu li a{padding:3px 10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/pagination_controls.scss
// module id = 1483
// module chunks = 0